import React from 'react';
import { FormattedMessage } from 'react-intl';
import Select from 'react-select';


const GestionarTransportadorasGrid = ({ transportadoras, selectedTransportadoras, onChangeTransportadoras, disabled }) => (
  <div className="card" style={{ minHeight: '300px' }}>
    <div className="card-content">
      <div className="card-body" style={{ minHeight: '300px', display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }}>
        <div className="form-group" style={{ minHeight: '120px' }}>
          <label htmlFor="transportadora">
            <FormattedMessage id="movilesAbm.render.general_data.placeholder_funcion" defaultMessage="Seleccione Transportadoras" />
          </label>
          <Select
            id="transportadora"
            name="transportadora"
            placeholder={"Seleccione Transportadoras"}
            options={transportadoras}
            valueKey="id"
            labelKey="nombre"
            multi
            value={selectedTransportadoras || []}
            onChange={onChangeTransportadoras}
            disabled={disabled}
            menuPlacement="auto"
            menuShouldScrollIntoView={false}
            styles={{ menu: (provided) => ({ ...provided, maxHeight: 250 }) }}
          />
        </div>
      </div>
    </div>
  </div>
);

export default GestionarTransportadorasGrid;